import React, { useState } from 'react';
import './index.css';

const Toggle = (props) => {
    const [toggle,
        setToggle] = useState(props.value || false);

    const handleChange = () => {
        setToggle(!toggle);

        toggle
            ? props.deactivate && props.deactivate()
            : props.activate && props.activate()
    }
    return (
        <div className={ props.className }>
            <div
                className={ `${toggle
                    ? 'toggleBtnActive'
                    : 'toggleBtn'} clickable mAuto alignOnly px-1` }
                onClick={ handleChange }>
                { toggle
                    ? <div className="toggleDotActive"></div>
                    : <div className="toggleDot"></div> }
            </div>
        </div>
    )
}

export default Toggle;
